function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "m7.32 2.33-3.08 3.05 9.19.04c.59 0 1.07.48 1.07 1.08 0 .59-.48 1.07-1.08 1.07l-9.19-.04 3.04 3.08c.42.42.41 1.1 0 1.51-.42.42-1.1.41-1.51 0l-5.01-5.07c-.34-.35-.34-.9 0-1.24l5.06-5c.42-.42 1.1-.41 1.51 0 .42.42.41 1.1 0 1.51z",
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10
});
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 15 12.92"
  }, props), _ref);
};
export default __webpack_public_path__ + "static/media/arrow-outlined-left.13deccb6.svg";
export { SvgComponent as ReactComponent };